import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";

const QuickBar = () => {
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");

  const handlerPostContact = async () => {
    if (!name || !phone) {
      Swal.fire({
        title: "기본 정보를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    // setLoading(true);

    await axios
      .post("/api/contact/quick", {
        name: name,
        phone: phone,
        type: "하단바",
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.result === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        // setLoading(false);
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };
  return (
    <div className="fixed bottom-9 left-0 z-50 hidden w-full bg-transparent pl-[calc((100%-var(--container))/2)] pr-72 lg:block ">
      <div className="text-center flex items-center justify-between gap-4 rounded-full bg-[rgba(15,26,71,0.95)] border border-white px-8 2xl:px-12 py-3 shadow-lg">
        {/* 왼쪽 텍스트 */}
        <img
          src="/images/whiteLogo.png"
          alt="스마트장인누수 로고"
          className="!relative w-auto h-full lg:max-h-10 xl:max-h-14 py-1 object-contain cursor-pointer"
          width={341}
          height={113}
        />
        <p className="!font-extrabold text-point text-4xl 2xl:text-5xl manru pt-1">
          010.8912.1202
        </p>

        {/* 입력 영역 */}
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="이름"
          className="h-12 w-full rounded-md px-3 text-xl outline-none text-center"
        />

        <input
          value={phone}
          onChange={(e) => setPhone(e.target.value.replace(/[^0-9]/g, ""))}
          placeholder="연락처"
          inputMode="numeric"
          maxLength={11}
          className="h-12 w-full rounded-md px-3 text-xl outline-none text-center"
        />

        <button
          type="button"
          onClick={handlerPostContact}
          className="h-10 px-2"
        >
          <p className="text-2xl 2xl:text-3xl pt-1.5 text-point">전송</p>
        </button>
      </div>
    </div>
  );
};

export default QuickBar;
